import axios from "axios";
import { useEffect, useState } from "react";

import { Loading, Grid } from "@nextui-org/react";

import { ToastContainer, toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { fetchUsers } from "../../../../../redux/reducer/postFetcReducer/action/action";
import sockets from "../../../../../socket/socket";
const socket = sockets;
export default function DeletWorkersInCopmay({item,btnload}) {

    
    const [load,setLoad]=useState(false);
    let getCompanyID = useSelector(compID => compID.checkedSessionReducer);
    const dipatch = useDispatch()
        useEffect(()=>{
                setLoad(btnload)
        },[btnload])

    const deleteWorker=(deleteWorker)=>{

        setLoad(true)
      
         axios.delete('/alldeploy/api',
         { data: { deleteWorker} }
         ).then(deletes=>{
         
          // SOCKET UPDATE IN SERVER
          socket.emit('updateemployeeServerSocket',{companyIDS:getCompanyID.checkedSession});
              toast.success(deletes.data.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
         }).catch(error=>{
             // SOCKET UPDATE IN SERVER
          socket.emit('updateemployeeServerSocket',{companyIDS:getCompanyID.checkedSession});
          toast.error(error.response.data.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            });
          
         }).finally(fin=>{
             // SOCKET UPDATE IN SERVER
          socket.emit('updateemployeeServerSocket',{companyIDS:getCompanyID.checkedSession});
          dipatch(fetchUsers())
          setLoad(false)
         })
      }

      if (load) {
        return <Loading type="points" style={{display:"flex"}}/>
       }else{
         return (
           <div className="divDeleteBTN" onClick={()=>deleteWorker(item) }>
              <p>Удалить</p>
              <span className="material-symbols-outlined" id="delete" >delete</span>
           </div>
         )
       }
}